import {
  CHANNEL_DISTRIBUTION,
  INFLOW_ACROSS_TIME,
  INFLOW_BY_CHANNEL,
  OPEN_CONVERSATION_INBOX,
  OPEN_CONVERSATION_INBOX_PRIORITY,
  OPEN_CONVERSATION_INBOX_STATUS,
  USER_ACITIVITIES_TIME,
  OPEN_CONVERSATION_TIMETRACKING_PERCENTAGE,
  OPEN_CONVERSATION_TIMETRACKING_USERDATA,
} from 'actions/types'

export default function (state = {}, action) {
  switch (action.type) {
    case INFLOW_BY_CHANNEL:
      return {
        ...state,
        inflowChannel: action.payload,
      }
    case CHANNEL_DISTRIBUTION:
      return {
        ...state,
        channelDistrbution: action.payload,
      }
    case INFLOW_ACROSS_TIME:
      return {
        ...state,
        inflowAcrossTime: action.payload,
      }
    case USER_ACITIVITIES_TIME:
      return {
        ...state,
        userActivities: action.payload,
      }
    case OPEN_CONVERSATION_INBOX:
      return {
        ...state,
        openConversationInboxData: action.payload,
      }
    case OPEN_CONVERSATION_INBOX_PRIORITY:
      return {
        ...state,
        openConversationInboxPriorityData: action.payload,
      }
    case OPEN_CONVERSATION_INBOX_STATUS:
      return {
        ...state,
        openConversationInboxStatusData: action.payload,
      }

    case OPEN_CONVERSATION_TIMETRACKING_PERCENTAGE:
      return {
        ...state,
        timeTrackingPercentage: action.payload,
      }
    case OPEN_CONVERSATION_TIMETRACKING_USERDATA:
      return {
        ...state,
        timeTrackingUserData: action.payload,
      }
    default:
      return state
  }
}
